import React from 'react';

export default function newLineFromComma(description) {
	if (!description) {
		return description;
	}
	// description = description.replace(new RegExp(',', 'g'), ',\n');
	return	description.split('\n').map((item, idx) => {
		if (item === '' || item === ' ') {
			return (
				<span />
			);
		}
		return (
			<span key={idx}>
				{item}
				<br />
			</span>
		)
	});
}
